var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNcNewCaledonia(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_21439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V45H60V0Z",
    fill: "#009543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V30H60V0Z",
    fill: "#ED4135"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H0V15H60V0Z",
    fill: "#0035AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5002 37.2467C29.3557 37.2467 22.7533 30.6443 22.7533 22.4998C22.7533 14.3553 29.3557 7.75293 37.5002 7.75293C45.6447 7.75293 52.2471 14.3553 52.2471 22.4998C52.2471 30.6443 45.6447 37.2467 37.5002 37.2467Z",
    fill: "#FAE600"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.4998 8.00176C45.5071 8.00176 51.9982 14.4929 51.9982 22.5002C51.9982 30.5075 45.5071 36.9986 37.4998 36.9986C29.4925 36.9986 23.0014 30.5075 23.0014 22.5002C23.0014 14.4929 29.4925 8.00176 37.4998 8.00176ZM52.4951 22.5002C52.4951 14.2185 45.7815 7.50488 37.4998 7.50488C29.2181 7.50488 22.5045 14.2185 22.5045 22.5002C22.5045 30.7819 29.2181 37.4955 37.4998 37.4955C45.7815 37.4955 52.4951 30.7819 52.4951 22.5002Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0029 24.7029H35.0061H40.0029ZM40.0029 20.9998H35.0061H40.0029ZM37.4998 7.7998V32.9998V7.7998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7998 20.6998V7.7998H37.1998V20.6998H35.0061V21.2998H37.1998V24.4029H35.0061V25.0029H37.1998V32.9998H37.7998V25.0029H40.0029V24.4029H37.7998V21.2998H40.0029V20.6998H37.7998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4434 36.0376C37.4246 38.5032 31.7809 36.197 31.7809 36.197C31.7809 36.197 33.909 33.8907 34.9965 32.9907C36.0652 32.1095 39.1965 32.147 40.2652 32.9907C41.3728 33.9548 42.4334 34.9716 43.4434 36.0376Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5004 31.697C36.5891 31.697 35.8504 30.6225 35.8504 29.297C35.8504 27.9715 36.5891 26.897 37.5004 26.897C38.4117 26.897 39.1504 27.9715 39.1504 29.297C39.1504 30.6225 38.4117 31.697 37.5004 31.697Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5002 24.1123C36.3974 24.1123 35.5033 23.5457 35.5033 22.8467C35.5033 22.1477 36.3974 21.5811 37.5002 21.5811C38.603 21.5811 39.4971 22.1477 39.4971 22.8467C39.4971 23.5457 38.603 24.1123 37.5002 24.1123Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5002 18.9938C36.3974 18.9938 35.5033 18.0997 35.5033 16.9969C35.5033 15.894 36.3974 15 37.5002 15C38.603 15 39.4971 15.894 39.4971 16.9969C39.4971 18.0997 38.603 18.9938 37.5002 18.9938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1002 9.55332C35.1002 9.55332 34.9314 9.83457 35.2877 10.4908C37.0314 13.6314 38.7846 13.6971 39.1127 13.9689C39.4877 14.2689 39.6377 14.2502 39.6377 14.2502C39.6096 13.9783 39.5908 12.8814 39.5721 12.7783C39.3002 11.3064 37.0877 11.3252 35.3533 9.8252C35.0814 9.59082 35.1002 9.54395 35.1002 9.54395V9.55332ZM40.9502 16.3033C40.9502 16.3033 40.5471 17.4283 40.5002 18.5533C40.4064 20.3533 38.6814 20.4002 37.5002 20.4002V19.3971C38.3908 19.3971 39.1596 19.2658 39.7971 17.9533C40.1325 17.3707 40.5183 16.8186 40.9502 16.3033ZM40.9971 30.7971C40.9971 30.7971 40.3689 30.0189 39.6283 28.2002C39.2533 27.2533 38.3346 26.7002 37.5002 26.7002V25.2939C39.4033 25.2939 40.3127 25.9971 40.4064 27.0377C40.5258 28.3018 40.723 29.5573 40.9971 30.7971Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.05 16.3032C34.05 16.3032 34.4531 17.4282 34.5 18.5532C34.5938 20.3532 36.3187 20.4001 37.5 20.4001V19.4063C36.6094 19.4063 35.8406 19.2751 35.2031 17.9532C34.8656 17.372 34.4813 16.8188 34.05 16.3032ZM34.0031 30.8063C34.0031 30.8063 34.6312 30.0188 35.3719 28.2001C35.7469 27.2532 36.6656 26.7001 37.5 26.7001V25.3126C35.5969 25.3126 34.6875 26.0157 34.5938 27.0563C34.4741 28.3173 34.2768 29.5697 34.0031 30.8063Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_21439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNcNewCaledonia);
export default __webpack_public_path__ + "static/media/nc New Caledonia.fda24faf7eac1aa52f580c390176dcf5.svg";
export { ForwardRef as ReactComponent };